
//  to make all route work, 
//  add route path in index.js 



import React, { Suspense, lazy} from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import ErrorComp from "../components/common/errorComp";
import Preview from './preview'
import WithAuthenticator from "../components/withAuthenticator";


const SubmitForm = lazy(() => import('./submitFormRest'));
// const SearchForm = lazy(() => import('../components/admins/doctorAdmin/searchForm'));

const Routes = props => {
  return (
    <Router>
        <ErrorComp>
            <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                    <Route exact path="/" render={()=>{
                       return <SubmitForm/>
                    }}/>
                    <Route exact path="/submitForm" render={()=>(<SubmitForm />)}/>
                    <Route exact path="/preview" render={() => <Preview />} />

                    {/* <Route exact path="/searchForm" render={()=>(<SearchForm />)}/> */}


            <Route render={() => <ErrorComp role={props.role} />} />
          </Switch>
        </Suspense>
      </ErrorComp>
    </Router>
  );
};

export default WithAuthenticator(Routes);
